import React from 'react';
import { useAdmin } from '../../../base/AdminContext';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import { Menubar } from 'primereact/menubar';
import { BreadCrumb } from 'primereact/breadcrumb';
import { useNavigate } from 'react-router-dom';
import useBreadcrumb from './useBreadcrumb';


interface AdminHeaderProps {
    onToggleSidebar: () => void;
    sidebarVisible: boolean;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ onToggleSidebar, sidebarVisible }) => {
    const { admin, logout } = useAdmin();
    const navigate = useNavigate();
    const breadcrumbs = useBreadcrumb();

    const handleLogout = () => {
        if (window.confirm('Bạn có chắc chắn muốn đăng xuất?')) {
            logout();
        }
    };

    // Convert breadcrumbs to PrimeBreadcrumb format
    const breadcrumbItems = breadcrumbs.map((item, index) => ({
        label: item.label,
        icon: item.icon,
        command: item.path ? () => navigate(item.path!) : undefined
    }));

    const home = {
        icon: 'pi pi-home',
        command: () => navigate('/admin/dashboard')
    };

    const start = (
        <div className="flex align-items-center">
            <Button
                icon={sidebarVisible ? "pi pi-times" : "pi pi-bars"}
                className="p-button-text p-button-sm mr-3"
                onClick={onToggleSidebar}
            />
            <div className="breadcrumb-container">
                <BreadCrumb
                    model={breadcrumbItems}
                    home={home}
                    className="border-none bg-transparent"
                />
            </div>
        </div>
    );

    const end = (
        <div className="flex align-items-center gap-3">
            {/* Notifications */}
            <div className="relative">
                <Button
                    icon="pi pi-bell"
                    className="p-button-text p-button-sm"
                    badge="3"
                    badgeClassName="p-badge-danger"
                />
            </div>

            {/* User Profile */}
            <div className="flex align-items-center">
                <div className="text-right mr-3 hidden sm:block">
                    <div className="text-900 font-semibold text-sm">{admin?.full_name}</div>
                    <div className="text-600 text-xs">Admin</div>
                </div>
                <Avatar
                    icon="pi pi-user"
                    size="normal"
                    shape="circle"
                    className="bg-primary text-white cursor-pointer"
                    onClick={handleLogout}
                />
                <Button
                    icon="pi pi-chevron-down"
                    className="p-button-text p-button-sm ml-1"
                />
            </div>
        </div>
    );

    return (
        <div className="admin-header">
            <Menubar
                start={start}
                end={end}
                className="border-none px-4 py-3"
            />

            <style>{`
                .admin-header {
                    background: #ffffff;
                    border-bottom: 1px solid #e5e7eb;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                }

                .admin-header .p-menubar {
                    background: transparent;
                    border: none;
                    padding: 0;
                }

                .breadcrumb-container {
                    font-size: 0.875rem;
                }

                .breadcrumb-container .p-breadcrumb {
                    background: transparent;
                    border: none;
                    padding: 0;
                }

                .breadcrumb-container .p-breadcrumb .p-breadcrumb-list {
                    font-size: 0.875rem;
                }

                .breadcrumb-container .p-breadcrumb .p-menuitem-text {
                    color: #6b7280;
                }

                .breadcrumb-container .p-breadcrumb .p-menuitem-link:hover .p-menuitem-text {
                    color: #374151;
                }

                .p-button.p-button-text {
                    color: #6b7280;
                }

                .p-button.p-button-text:hover {
                    color: #374151;
                    background: #f3f4f6;
                }

                .p-badge {
                    min-width: 1.25rem;
                    height: 1.25rem;
                    font-size: 0.75rem;
                }

                .p-avatar {
                    width: 2.5rem;
                    height: 2.5rem;
                    transition: all 0.3s ease;
                }

                .p-avatar:hover {
                    transform: scale(1.05);
                }

                @media (max-width: 640px) {
                    .admin-header .p-menubar {
                        padding: 0.75rem 1rem;
                    }
                    
                    .breadcrumb-container {
                        display: none;
                    }
                }
            `}</style>
        </div>
    );
};

export default AdminHeader;
